import React, { Component } from 'react';
import { Row, Col, Input, Form, FormGroup, Button } from 'reactstrap';

class Marketing2Textarea extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectionStart: null,
      selectedField: ''
    };

    this.fields = [
      'Sender First Name',
      'Sender Last Name',
      'Sender Contact Info',
      'Recipient First Name',
      'Recipient Last Name',
      'Current Date'
      // 'SEC Region',
      // 'Organization CRD#',
      // 'SEC#',
      // 'Primary Business Name',
      // 'Main Office Street Address 1',
      // 'Main Office Street Address 2',
      // 'Main Office City',
      // 'Main Office State',
      // 'Main Office Country',
      // 'Main Office Postal Code',
      // 'Main Office Telephone Number',
      // 'Website Address'
    ]
  }

  onChangeHandler = (e) => {
    this.props.onChange(e, (this.props.edit ? 'edit' : null))
    this.setState({
      selectionStart: e.target.selectionStart
    })
  }

  setText = () => {
    const [textFirst, textLast] = [this.props.value.substring(0, this.state.selectionStart), this.props.value.substring(this.state.selectionStart, this.props.value.length)];
    this.props.onChange({
      persist: () => null,
      target: {
        name: this.props.name,
        value: textFirst + '${' + this.state.selectedField + '}' + textLast
      }
    }, (this.props.edit ? 'edit' : null))
  }

  render() {
    return (
      <Row className='pb-4'>
        <Col md={12} className="mt-2">
          <Input
            placeholder={this.props.placeholder}
            type="textarea"
            rows={6}
            name={this.props.name}
            value={this.props.value + ''}
            onChange={(e) => this.onChangeHandler(e)}
            onClick={(e) => this.onChangeHandler(e)}
            onKeyUp={(e) => this.onChangeHandler(e)}
          />
        </Col>
        <Col md={12} className="mt-2">
          <Form inline>
            <FormGroup>
              <Input
                onChange={(e) => this.setState({ selectedField: e.target.value })}
                type="select">
                <option value=''>INSERT FIELD</option>
                {this.fields.map(field => (
                  <option key={field}>{field}</option>
                ))}
              </Input>
              <Button
                onClick={this.setText}
                className="ml-2">
                Insert
              </Button>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    );

  }
}

export default Marketing2Textarea;
